import React, { useState } from 'react';
import DragHandleIcon from '../atoms/DragHandleIcon';
import Input from '../atoms/Input';
import Select from '../atoms/Select';
import Toggle from '../atoms/Toggle';
import TrashIcon from '../atoms/TrashIcon';

export const FIELD_TYPE_OPTIONS = ['Custom', 'Text', 'Number', 'Date', 'Dropdown', 'Checkbox', 'Radio'];
export const FIELD_ACCESS_OPTIONS = ['All', 'Admin', 'Manager', 'Staff'];
export const HIDE_FOR_OPTIONS = ['Level 1', 'Level 2', 'Level 3'];

export default function FormCard({ field, fieldOptions = [], onChange, onDelete }) {
  const [optionDraft, setOptionDraft] = useState('');
  const update = (patch) => onChange?.({ ...field, ...patch });
  const addOption = () => {
    const option = optionDraft.trim();
    if (!option || field.options?.includes(option)) return;
    update({ options: [...(field.options || []), option] });
    setOptionDraft('');
  };
  const removeOption = (option) => update({ options: field.options.filter((item) => item !== option) });

  return (
    <article className="ca-form-card">
      <div className="ca-form-card__row ca-form-card__row--order">
        <DragHandleIcon size={15} color="#111827" />
        <button type="button" className="ca-icon-btn ca-form-card__delete" aria-label="Delete form field" onClick={() => onDelete?.(field.id)}>
          <TrashIcon size={15} />
        </button>
      </div>
      <div className="ca-form-card__row">
        <Input value={field.fieldLabel} placeholder="Enter field label" onChange={(event) => update({ fieldLabel: event.target.value })} />
      </div>
      <div className="ca-form-card__row">
        <Select value={field.fieldType} options={FIELD_TYPE_OPTIONS} placeholder="Select type" onChange={(event) => update({ fieldType: event.target.value })} />
      </div>
      <div className="ca-form-card__row ca-form-card__row--toggle">
        <Toggle checked={Boolean(field.required)} onChange={(required) => update({ required })} aria-label="Required" />
      </div>
      <div className="ca-form-card__row">
        <Select value={field.fieldAccess} options={field.fieldAccess && !FIELD_ACCESS_OPTIONS.includes(field.fieldAccess) ? [field.fieldAccess, ...FIELD_ACCESS_OPTIONS] : FIELD_ACCESS_OPTIONS} placeholder="Select access" onChange={(event) => update({ fieldAccess: event.target.value })} />
      </div>
      <div className="ca-form-card__row">
        <Select value="" options={HIDE_FOR_OPTIONS.filter((item) => !field.hideFor?.includes(item))} placeholder="Select level" onChange={(event) => update({ hideFor: [...(field.hideFor || []), event.target.value] })} />
        {field.hideFor?.length ? <div className="ca-form-card__chips">{field.hideFor.map((item) => <span key={item} className="ca-form-card__chip">{item}<button type="button" aria-label={`Remove ${item}`} onClick={() => update({ hideFor: field.hideFor.filter((value) => value !== item) })}>×</button></span>)}</div> : null}
      </div>
      <div className="ca-form-card__row">
        <Select value={field.dependsOn} options={fieldOptions} placeholder="Select field label" onChange={(event) => update({ dependsOn: event.target.value })} />
      </div>
      <div className="ca-form-card__row ca-form-card__row--options">
        <div className="ca-form-card__option-entry">
          <Input value={optionDraft} placeholder="Enter option" onChange={(event) => setOptionDraft(event.target.value)} onKeyDown={(event) => { if (event.key === 'Enter') { event.preventDefault(); addOption(); } }} />
          <button type="button" className="ca-form-card__add-option" aria-label="Add option" onClick={addOption}>+</button>
        </div>
        <div className="ca-form-card__chips">
          {(field.options || []).map((option) => <span className="ca-form-card__chip" key={option}>{option}<button type="button" aria-label={`Remove ${option}`} onClick={() => removeOption(option)}>×</button></span>)}
        </div>
      </div>
    </article>
  );
}